import React, { useState } from 'react';

import {
    Text,
    Radio,
    Spacer,
    Label,
    LabeledControl,
} from '@zillow/constellation';

const HousingConnector = ({ initSelectedOption, handleSelectChange }) => {
    const OPTIONS = {
        GLOBAL: 'global',
        DISABLED: 'disabled',
        EXCLUSIVE: 'exclusive',
    };

    const [selectedOption, setSelectedOption] = useState(initSelectedOption);

    const title = 'Where to post this listing';
    const description = 'Zillow Rental Network sites include HotPads, Trulia, Zillow. ' +
        'Housing Connector will share your listing with nonprofit agencies and ' +
        'display the modified screening criteria that you specified.';
    const contentGlobal = 'Both Zillow Rental Network and Housing Connector';
    const contentDisabled = 'Only Zillow Rental Network';
    const contentExclusive = 'Only Housing Connector';

    const handleChange = (selected) => {
        setSelectedOption(selected);
        handleSelectChange('seattleHousingConnectorStatus', selected);
    };

    return (
        <div className="HousingConnector">
            <Text
                as="div"
                fontType="h4"
                marginBottom="xs"
                mediaQuery={{
                    md: {
                        marginBottom: 'sm',
                    },
                }}
            >
                {title}
            </Text>

            <Text
                as="div"
                fontType="body"
                marginBottom="sm"
            >
                {description}
            </Text>

            <div className="HousingConnector-FormField-Container">
                <LabeledControl
                    controlId="LabeledControl-HousingConnector1"
                    label={<Label>{contentGlobal}</Label>}
                    control={(
                        <Radio
                            checked={selectedOption === OPTIONS.GLOBAL}
                            onChange={() => handleChange(OPTIONS.GLOBAL)}
                        />
                    )}
                />
                <LabeledControl
                    controlId="LabeledControl-HousingConnector2"
                    label={<Label>{contentDisabled}</Label>}
                    control={(
                        <Radio
                            checked={selectedOption === OPTIONS.DISABLED}
                            onChange={() => handleChange(OPTIONS.DISABLED)}
                        />
                    )}
                />
                <LabeledControl
                    controlId="LabeledControl-HousingConnector3"
                    label={<Label>{contentExclusive}</Label>}
                    control={(
                        <Radio
                            checked={selectedOption === OPTIONS.EXCLUSIVE}
                            onChange={() => handleChange(OPTIONS.EXCLUSIVE)}
                        />
                    )}
                />
                <Spacer marginY="lg" />
            </div>
        </div>
    );
};

export default HousingConnector;
